import valid from "card-validator";

const removeNonNumber = (string = "") => string.replace(/[^\d]/g, "");
const removeLeadingSpaces = (string = "") => string.replace(/^\s+/g, "");
const limitLength = (string = "", maxLength) => string.substr(0, maxLength);
const addGaps = (string = "", gaps) => {
    const offsets = [0].concat(gaps).concat([string.length]);

    return offsets.map((end, index) => {
        if (index === 0) return "";
        const start = offsets[index - 1];
        return string.substr(start, end - start);
    }).filter(part => part !== "").join(" ");
};

const FALLBACK_CARD = {
    gaps: [4, 8, 12],
    lengths: [16, 18, 19],
    code: {
        size: 3
    }
};
export default class CCFieldFormatter {
    constructor() {
        // this.card;
    }

    formatAndValidateNumber = (number) => {
        this.card = valid.number(number).card || FALLBACK_CARD;
        const numberSanitized = removeNonNumber(number);
        const maxLength = this.card.lengths[this.card.lengths.length - 1];
        const lengthSanitized = limitLength(numberSanitized, maxLength);
        const formatted = addGaps(lengthSanitized, this.card.gaps);
        return ({
            formatted: formatted,
            nonFormatted: numberSanitized,
            isPotentiallyValid: valid.number(number).isPotentiallyValid,
            isValid: valid.number(number).isValid,
            type: valid.number(number).card ? valid.number(number).card.niceType.toLowerCase() : undefined
        })
    };

    formatAndValidateExpiry = (expiry) => {
        var sanitized = limitLength(removeNonNumber(expiry), 4);
        var isPotentiallyValid = valid.expirationMonth(sanitized).isPotentiallyValid;

        if (sanitized.length > 2) {
            sanitized = `${sanitized.substr(0, 2)}/${sanitized.substr(2, sanitized.length)}`;
            isPotentiallyValid = valid.expirationDate(sanitized).isPotentiallyValid
        }

        return ({
            formatted: sanitized,
            isPotentiallyValid: isPotentiallyValid,
            isValid: valid.expirationDate(sanitized).isValid,
            month: valid.expirationDate(sanitized).month,
            year: valid.expirationDate(sanitized).year,
        });
    };

    formatAndValidateCVC = (cvc) => {
        const card = this.card || FALLBACK_CARD;
        const maxCVCLength = card.code.size;
        const formatted = limitLength(removeNonNumber(cvc), maxCVCLength);
        return ({
            formatted: formatted,
            isPotentiallyValid: valid.cvv(formatted, maxCVCLength).isPotentiallyValid,
            isValid: valid.cvv(formatted, maxCVCLength).isValid,
        })
    };
}